<template>
  <b-modal
    id="ecode-redeem-success-modal"
    hide-header
    size="sm"
    footer-class="border-top-0 justify-content-center"
    centered
    content-class="text-center p-4"
  >
    <p class="mb-0"> {{ redeemMessage ? redeemMessage : "" }} </p>
    <template slot="modal-footer">
      <b-button
        pill
        variant="secondary"
        class="px-5"
        @click="closeModal">
        Close
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters("reward", ["redeemMessage"])
  },
  methods: {
    closeModal() {
      this.$emit("clearCodeField");
      this.$root.$emit('bv::hide::modal', 'ecode-redeem-success-modal')
    }
  }
}
</script>
